import mitt from "mitt";

export interface NotificationContent {
  title?: string;
  text?: string;
}

export type NotificationType = "success" | "error" | "warning";

export type NotificationPayload = {
  type: NotificationType;
} & NotificationContent;

export const notifyEmitter = mitt<{
  add: NotificationPayload;
}>();

export const notify = {
  success: (props: NotificationContent) => {
    notifyEmitter.emit("add", {
      type: "success",
      ...props,
    });
  },
  error: (props: NotificationContent) => {
    notifyEmitter.emit("add", {
      type: "error",
      ...props,
    });
  },
  warning: (props: NotificationContent) => {
    notifyEmitter.emit("add", {
      type: "warning",
      ...props,
    });
  },
};
